import useTimeZoneClock from 'hooks/useTimeZoneClock';
import { getBackgroundStyle } from 'components/common/TableColor';
import { cdn } from "constants/common";
import moment from 'moment';
import React from 'react'

const InterpreterTranslationViewTable = React.memo(({ item, onAccept, onReject, hideActions }) => {

    const timeZone = useTimeZoneClock(item?.datetime);
    const formattedDate = moment(timeZone).format('MMMM DD YYYY');
    const formattedTime = moment(timeZone).format('hh:mm A');

    const InfoRow = ({ label, value, toLowerCase = "" }) => (
        <div className='row_detail_tab'>
            <div className='label_view'><strong>{label}</strong></div>
            <div className={`detail_view ${toLowerCase}`}>{value || 'N/A'}</div>
        </div>
    );

    const rowDash1Style = {
        display: 'flex',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };

    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };

    const marginTopZero = {
        marginTop: 0
    };
    console.log(item, 'itemmmmm');
    return (
        <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
            <div className="row_dash_1" style={rowDash1Style}>
                <div className="card_table" style={marginTopZero}>

                    {/* Translation Info */}
                    <div className="Table_data_show Table_data_show1 pt-0">
                        <h2 style={{ fontSize: '17px', marginBottom: '12px' }}>Translation Information:</h2>
                        <table className="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Request ID:</td>
                                    <td className="bg-primary-secondary">#{item?.transid}</td>
                                </tr>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Requester Name:</td>
                                    <td className="bg-primary-secondary">{item?.requester_name}</td>
                                </tr>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Requester Email:</td>
                                    <td className="bg-primary-secondary">{item?.translation_details?.requester_email}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Requested At + Due Date */}
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table className="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Requested At:</td>
                                    <td className="bg-primary-secondary">{item?.created_at && moment(item?.created_at).format("MMM D, YYYY HH:mm:ss")}</td>
                                </tr>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Due Date:</td>
                                    <td className="bg-primary-secondary">{item?.translation_details?.due_date}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Target Language + Department */}
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table className="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Target Language:</td>
                                    <td className="bg-primary-secondary">
                                        {Array.isArray(item.translation_target_languages) && item.translation_target_languages.length > 0
                                            ? item.translation_target_languages.map(tl => tl.language?.name).filter(Boolean).join(', ')
                                            : 'N/A'}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Department:</td>
                                    <td className="bg-primary-secondary">{item?.department || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Special Instructions + Description */}
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <table className="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Special Instructions :</td>
                                    <td className="bg-primary-secondary">{item.translation_details?.instructions || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Document Description:</td>
                                    <td className="bg-primary-secondary">{item.translation_details?.comment || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Number Of Pages:</td>
                                    <td className="bg-primary-secondary">{item?.translation_details?.pages}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Principal Info */}
                    <div className="Table_data_show Table_data_show1 pt-0">
                        <table className="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Director, Principal, or Designee:</td>
                                    <td className="bg-primary-secondary">{item?.principal || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Email for Director, Principal, or Designee:</td>
                                    <td className="bg-primary-secondary">{item?.translation_details?.principal_email || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Translator Info */}
                    <div className="Table_data_show Table_data_show1 pt-0 ">
                        <h2 style={{ fontSize: '17px', marginBottom: '12px', marginTop: '10px' }}>Translator Information:</h2>
                        <table className="bg-primary-secondary table">
                            <tbody>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Name:</td>
                                    <td className="bg-primary-secondary">{item?.interpreter?.user?.name}</td>
                                </tr>
                                <tr>
                                    <td className="bg-primary-secondary" style={{ width: "40%" }}>Phone:</td>
                                    <td className="bg-primary-secondary">{item?.interpreter?.phone || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Revision Info */}
                    {!hideActions && (
                        <div className="Table_data_show Table_data_show1 pt-0 ">
                            <h2 style={{ fontSize: '17px', marginBottom: '12px', marginTop: '10px' }}>Revision Request:</h2>
                            <table className="bg-primary-secondary table">
                                <tbody>
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>Due Date:</td>
                                        <td className="bg-primary-secondary">{item?.translation_details?.requested_due_date}</td>
                                    </tr>
                                    <tr>
                                        <td className="bg-primary-secondary" style={{ width: "40%" }}>Reason:</td>
                                        <td className="bg-primary-secondary">{item?.translation_details?.cancel_reason || 'N/A'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                    {/* Actions */}
                    {!hideActions && (
                        <div className="actions">
                            <button
                                onClick={() => onAccept && onAccept(item)}
                                className="main_button green"
                            >
                                Accept
                            </button>
                            <button
                                onClick={() => onReject && onReject(item)}
                                className="main_button tomatoRed"
                            >
                                Reject
                            </button>
                        </div>
                    )}
                    {/* link */}
                    {item?.status === 'Completed' && item?.translation_translated_files?.[0] && (
                        <div>
                            <h2 style={{ fontSize: '17px', marginBottom: '12px', marginTop: '10px' }}>Translated File:</h2>
                            <a
                                href={cdn + item.translation_translated_files[0].file_path}
                                download
                                className="main_button green"
                            >
                                Download Translated File
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
})

export default InterpreterTranslationViewTable;
